"use strict";

// Manages header group behaviour based on scroll position and viewport size
function headerGroupScrollBehaviour() {
  var DESKTOP_BREAKPOINT = 990;
  var isScrolledPast = false; // Whether main content has scrolled past the threshold
  var scrollListenerActive = false; // Whether the scroll listener is currently attached

  // Track original DOM position of cart icon for restoration on desktop
  var cartIconOriginalParent = null;
  var cartIconNextSibling = null;

  // Returns all required DOM elements, or null if any are missing
  function getElements() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return null;
    var announcement = headerGroup.querySelector('.announcement');
    var header = headerGroup.querySelector('.header');
    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!announcement || !header || !cartIconBubble) return null;
    var mainContent = document.querySelector('#MainContent');
    if (!mainContent) return null;
    var headerCartContainer = header.querySelector('.header__cart-container');
    if (!headerCartContainer) return null;
    var accountIcon = header.querySelector('.header__icon--account');
    if (!accountIcon) return null;
    var mobNavIcon = header.querySelector('.menu-drawer-container .header__icon');
    if (!mobNavIcon) return null;
    return {
      headerGroup: headerGroup,
      announcement: announcement,
      header: header,
      headerCartContainer: headerCartContainer,
      cartIconBubble: cartIconBubble,
      mainContent: mainContent,
      accountIcon: accountIcon,
      mobNavIcon: mobNavIcon
    };
  }

  // Update header appearance based on current scroll position
  function updateDesktopState() {
    var elements = getElements();
    if (!elements) return;
    isScrolledPast = elements.mainContent.getBoundingClientRect().top <= 45;
    var headerWrapper = elements.headerGroup.querySelector('.header-wrapper');
    if (isScrolledPast) {
      // Scrolled past threshold: hide announcement bar, show cart and account icons
      elements.headerGroup.classList.add('announcement-hidden');
      headerWrapper.classList.add('header-wrapper--border-bottom');
      positionCartIcon(elements.headerCartContainer, elements.cartIconBubble, true);
      showAccountIcon(elements.accountIcon);
    } else {
      // At top: show announcement bar, hide cart and account icons
      elements.headerGroup.classList.remove('announcement-hidden');
      headerWrapper.classList.remove('header-wrapper--border-bottom');
      positionCartIcon(elements.headerCartContainer, elements.cartIconBubble, false);
      hideAccountIcon(elements.accountIcon);
    }
  }

  // Toggle cart icon visibility and position within the header cart container
  function positionCartIcon(headerCartContainer, cartIconBubble, announcementHidden) {
    cartIconBubble.style.top = announcementHidden ? '15px' : '0';
    headerCartContainer.style.opacity = announcementHidden ? '1' : '0';
    headerCartContainer.style.width = announcementHidden ? '40px' : '0';
  }
  function showAccountIcon(accountIcon) {
    accountIcon.classList.remove('is-hidden');
    accountIcon.style.opacity = '1';
    accountIcon.style.width = '40px';
  }
  function hideAccountIcon(accountIcon) {
    accountIcon.classList.add('is-hidden');
    accountIcon.style.opacity = '0';
    accountIcon.style.width = '0';
  }

  // Move cart icon into the header container for mobile layout
  function moveCartIconToHeader(cartIconBubble, headerCartContainer, mobNavIcon) {
    if (!cartIconOriginalParent) {
      cartIconOriginalParent = cartIconBubble.parentNode;
      cartIconNextSibling = cartIconBubble.nextSibling;
    }
    headerCartContainer.appendChild(cartIconBubble);
    headerCartContainer.style.opacity = '1';
    headerCartContainer.style.width = '40px';
    mobNavIcon.style.opacity = '1';
    mobNavIcon.style.width = '40px';
    cartIconBubble.style.top = '';
  }

  // Restore cart icon to its original DOM position for desktop
  function restoreCartIconToOriginal(cartIconBubble) {
    if (cartIconOriginalParent) {
      cartIconOriginalParent.insertBefore(cartIconBubble, cartIconNextSibling);
      cartIconOriginalParent = null;
      cartIconNextSibling = null;
    }
  }

  // Attach scroll listener and apply initial desktop state
  function enableDesktopBehavior() {
    var elements = getElements();
    if (!elements) return;
    restoreCartIconToOriginal(elements.cartIconBubble);
    if (!scrollListenerActive) {
      window.addEventListener('scroll', updateDesktopState, {
        passive: true
      });
      scrollListenerActive = true;
    }
    updateDesktopState();
  }

  // Remove scroll listener and apply mobile layout
  function disableDesktopBehavior() {
    if (scrollListenerActive) {
      window.removeEventListener('scroll', updateDesktopState);
      scrollListenerActive = false;
    }
    var elements = getElements();
    if (!elements) return;
    elements.headerGroup.classList.remove('announcement-hidden');
    moveCartIconToHeader(elements.cartIconBubble, elements.headerCartContainer, elements.mobNavIcon);
    showAccountIcon(elements.accountIcon);
    // Re-enable transitions after the paint to avoid animating the layout shift
    requestAnimationFrame(function () {
      elements.accountIcon.style.transition = '';
    });
  }

  // Switch between desktop and mobile behaviour on viewport change
  function onResize() {
    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      enableDesktopBehavior();
    } else {
      disableDesktopBehavior();
    }
  }
  onResize();
  window.addEventListener('resize', onResize);

  // Return a cleanup function to remove all listeners
  return function () {
    window.removeEventListener('resize', onResize);
    if (scrollListenerActive) {
      window.removeEventListener('scroll', updateDesktopState);
    }
  };
}

// Reinitialise, cleaning up any previous instance first
if (window.__headerGroupRepositionCleanup) {
  window.__headerGroupRepositionCleanup();
}
window.__headerGroupRepositionCleanup = headerGroupScrollBehaviour();